import React from 'react';
import { Button } from 'antd';
import GoogleIcon from 'assets/google-icon.svg';
import serverProxy from 'cvat-core/src/server-proxy';

interface GoogleAuthButtonProps {
    isLogin?: boolean;
}

const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({ isLogin = false }) => {
    const handleGoogleAuth = () => {
        if (isLogin) {
            serverProxy.server.googleLoginRedirect();
        } else {
            serverProxy.server.googleRegisterRedirect();
        }
    };

    return (
        <Button
            type="default"
            className="cvat-google-login-button"
            onClick={handleGoogleAuth}
            icon={<GoogleIcon />}
        >
            Continue with Google
        </Button>
    );
};

export default GoogleAuthButton;